import React from 'react';
import './HeroCard.css';

export default function HeroCard({ user, yearsActive }) {
  const joinYear = new Date(user.created_at).getFullYear();

  return (
    <div className="hero card card--mb">
      <div className="hero__accent" aria-hidden="true" />
      <div className="hero__inner">
        <div className="hero__avatar-wrap">
          <img
            className="hero__avatar"
            src={user.avatar_url}
            alt={user.login}
            loading="lazy"
          />
          {user.hireable && (
            <span className="hero__hire-badge">Open to work</span>
          )}
        </div>

        <div className="hero__info">
          <div className="hero__top">
            <div>
              <h1 className="hero__name">{user.name || user.login}</h1>
              <a
                href={`https://github.com/${user.login}`}
                target="_blank"
                rel="noreferrer"
                className="hero__handle"
              >
                @{user.login} ↗
              </a>
            </div>
            <div className="hero__since">
              <span className="hero__since-label">on GitHub since</span>
              <span className="hero__since-year">{joinYear}</span>
            </div>
          </div>

          {user.bio && (
            <p className="hero__bio">{user.bio}</p>
          )}

          <div className="hero__meta">
            {user.company && (
              <span className="hero__meta-item">
                <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M1.5 14.25c0 .138.112.25.25.25H4v-1.25a.75.75 0 011.5 0V14.5h5v-1.25a.75.75 0 011.5 0V14.5h2.25a.25.25 0 00.25-.25V1.75a.25.25 0 00-.25-.25h-10.5a.25.25 0 00-.25.25v12.5zM0 1.75C0 .784.784 0 1.75 0h10.5C13.216 0 14 .784 14 1.75v12.5A1.75 1.75 0 0112.25 16h-10.5A1.75 1.75 0 010 14.25V1.75zM6 3.5a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm-2 0a.5.5 0 01.5-.5h.5a.5.5 0 010 1H4.5a.5.5 0 01-.5-.5zm8 0a.5.5 0 01.5-.5h.5a.5.5 0 010 1h-.5a.5.5 0 01-.5-.5zM6 7a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1A.5.5 0 016 7zm-2 0a.5.5 0 01.5-.5h.5a.5.5 0 010 1H4.5A.5.5 0 014 7zm8 0a.5.5 0 01.5-.5h.5a.5.5 0 010 1h-.5A.5.5 0 0112 7z"/>
                </svg>
                {user.company.replace('@', '')}
              </span>
            )}
            {user.location && (
              <span className="hero__meta-item">
                <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
                  <path fillRule="evenodd" d="M11.536 3.464a5 5 0 010 7.072L8 14.07l-3.536-3.534a5 5 0 117.072-7.072v.001zm1.06 8.132a6.5 6.5 0 10-9.192 0l3.535 3.536a1.5 1.5 0 002.122 0l3.535-3.536zM8 9a2 2 0 100-4 2 2 0 000 4z"/>
                </svg>
                {user.location}
              </span>
            )}
            {user.blog && (
              <a
                href={user.blog.startsWith('http') ? user.blog : `https://${user.blog}`}
                target="_blank"
                rel="noreferrer"
                className="hero__meta-item hero__meta-link"
              >
                <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"/>
                </svg>
                {user.blog.replace(/^https?:\/\//, '')}
              </a>
            )}
          </div>
        </div>
      </div>

      {yearsActive > 0 && (
        <div className="hero__badge">
          <span className="hero__badge-num">{yearsActive}</span>
          <span className="hero__badge-label">year{yearsActive !== 1 ? 's' : ''} building</span>
        </div>
      )}
    </div>
  );
}
